// "May" when `month` falls in the same year as `today`, "January 2027" otherwise.
export function getMonthLabel(month: Date, today: Date): string {
    const isCurrentYear = month.getFullYear() === today.getFullYear();
    return month.toLocaleDateString(
        'en-US',
        isCurrentYear ? { month: 'long' } : { month: 'long', year: 'numeric' },
    );
}
